import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from 'bp/layout/layout.component';
import { AcceptedRiskGuard } from 'projects/bp-advisor/src/bp/shared/guards/accepted-risk.guard';
import { BpAuthGuard } from 'projects/bp-core/src/lib/services/portal/is-login.guard';
import { crmOnlyRedirectGuard } from './modules/crm/guards/crm-access.guard';
// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const bpAppRoutes: Route[] = [
  // Redirect TO dashboard
  { path: '', redirectTo: 'users', pathMatch: 'full' },

  // NO guard - NO sidebar - NO bpstepsheader
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      // Auth
      {
        path: 'auth',
        loadChildren: () => import('bp/modules/auth/auth.module').then(mod => mod.AuthModule),
      },

      // Maintenance
      {
        path: 'maintenance',
        loadChildren: () =>
          import('bp/modules/maintenance/maintenance.module').then(m => m.MaintenanceModule),
      },
    ],
  },

  // SÍ guard - si sidebar - NO bpstepsheader
  {
    path: '',
    // `crmOnlyRedirectGuard` (spec 032): un usuario exclusivamente de Customer Success solo
    // trabaja dentro del CRM — cualquier sección de asesores lo devuelve a `/crm`. Va sobre la
    // ruta PADRE para cubrir todas las secciones desde un único punto de control.
    canActivate: [BpAuthGuard, AcceptedRiskGuard, crmOnlyRedirectGuard],
    component: LayoutComponent,
    data: {
      layout: 'bp',
    },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      // Dashboard
      {
        path: 'dashboard',
        loadChildren: () =>
          import('bp/modules/dashboard/dashboard.module').then(m => m.DashboardModule),
      },

      // Asesor IA (049): el chat nuevo o el anterior según GetAvailability; el guard va en las rutas hijas
      {
        path: 'chat',
        loadChildren: () => import('bp/modules/asesor-ia/asesor-ia.routes'),
      },
      //users
      {
        path: 'users',
        loadChildren: () => import('bp/modules/users/users.module').then(m => m.UsersModule),
      },
      {
        path: 'onboarding',
        loadChildren: () => import('bp/modules/onboarding/onboarding.routes'),
      },
      {
        path: 'crm',
        loadChildren: () => import('bp/modules/crm/crm.routes'),
      },
      {
        // Feature 050: traspaso masivo de clientes (solo jefatura). Sin guard de redirección a
        // propósito: quien entra por URL sin rol ve el estado "sin permiso" del shell (FR-002).
        path: 'traspasos',
        loadChildren: () => import('bp/modules/client-transfers/client-transfers.routes'),
      },
      {
        path: 'operations',
        loadChildren: () => import('bp/modules/operations/operations.routes'),
      },
      {
        path: 'notes',
        loadChildren: () => import('bp/modules/notes/notes.routes'),
      },
      {
        path: 'notificaciones',
        loadChildren: () => import('bp/modules/notifications/notifications.routes'),
      },
    ],
  },

  // En duda si debe renderizarse
  {
    path: '',
    canActivate: [BpAuthGuard, crmOnlyRedirectGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'companies',
        loadChildren: () =>
          import('bp/modules/companies/companies.module').then(m => m.CompaniesModule),
      },
    ],
  },
];

export const notMatchRedirectRoutes: Route[] = [
  {
    path: 'redirect-to',
    pathMatch: 'full',
    loadChildren: () =>
      import('bp/modules/redirect/redirect.module').then(mod => mod.RedirectModule),
  },
  { path: '**', redirectTo: 'redirect-to' },
];

//{ path: '**', redirectTo: 'redirect-to', pathMatch: 'full' },
//{ path: '**', redirectTo: '404-not-found' },
